import { createContext, Dispatch, useContext } from "react";
import { LocationInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";
import { Graph_QL, SectionsInfo } from "../../../Services";

/* eslint-disable */
export enum currentLfViewTypes {
  basic = "basic",
  systemControle = "systemControle",
  attention = "attention",
  remainingToday = "remainingToday",
  remainingYesterday = "remainingYesterday"
}

export enum systemControleTypes {
  startSection = "startSection",
  calibrateSection = "calibrateSection",
  emptySection = "emptySection",
  gateControle = "gateControle",
  autoTune = "autoTune"
}

export enum ILfContextEnum {
  sections = "sections",
  // pens = "pens",
  currentPenViewType = "currentPenViewType",
  error = "error",
  clearError = "clearError",
  systemControlePen = "systemControlePen",
  penContent = "penContent",

  selectedPens = "selectedPens",
  selectedSection = "selectedSection",
  nextFeeding_LocationsToFeed = "nextFeeding_LocationsToFeed",
  locationResults = "locationResults",
}
/* eslint-enable */

export type ILfContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  systemId: number;

  sections?: SectionsInfo[];
  // pens?: Location[];
  currentPenViewType: currentLfViewTypes;
  penContent?: number;
  error: { Elementid: number, errorText: string };

  selectedPens?: LocationInfo[];
  selectedSection?: SectionsInfo;
  nextFeeding_LocationsToFeed?: LocationInfo[];
  locationResults?: { [key: number]: boolean };
  
  systemControlePen?: {
    systemControleType?: systemControleTypes;
    // selectedPens?: Location[];
    // nextFeeding_LocationsToFeed?: Location[];
    // locationResults?: {[key: number]: boolean};
  }
  
};

export type LfDispatcherT = Deep_Partial<ILfContext>;

type LfContexter = {
  state: ILfContext,
  dispatch: Dispatch<LfDispatcherT>
}

export const LfContext = createContext<LfContexter | undefined>(undefined);

export function LfReducer(state: ILfContext, action: LfDispatcherT) {
  let ResultState = { ...state };
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case ILfContextEnum.selectedSection: {
        const newSection = payload as SectionsInfo | undefined;
        const newSectionPens = newSection?.section_locations.map(loc => loc) ?? [];
        ResultState = {
          ...ResultState,
          selectedSection: newSection,
          // pens: newSectionPens,
          selectedPens: newSectionPens,
        };
        break;
      }
      case ILfContextEnum.selectedPens: {
        ResultState = {
          ...ResultState,
          selectedPens: payload as LocationInfo[]
        };
        break;
      }
      case ILfContextEnum.sections: {
        ResultState = {
          ...ResultState,
          sections: payload as SectionsInfo[]
        };
        break;
      }
      case ILfContextEnum.penContent: {
        ResultState = {
          ...ResultState,
          penContent: payload as number
        };
        break;
      }
      case ILfContextEnum.systemControlePen: {
        ResultState = {
          ...ResultState,
          systemControlePen: {
            ...(ResultState.systemControlePen ?? {}),
            systemControleType: (payload as {systemControleType: systemControleTypes}).systemControleType 
          }
        };
        break;
      }
      case ILfContextEnum.locationResults:
        ResultState = {
          ...ResultState,
          locationResults: payload as { [key: number]: boolean }
        };
        break;

      case ILfContextEnum.nextFeeding_LocationsToFeed:
        ResultState = {
          ...ResultState,
          nextFeeding_LocationsToFeed: payload as LocationInfo[]
        };
        break;

      case ILfContextEnum.currentPenViewType:
        ResultState = {
          ...ResultState,
          currentPenViewType: payload as currentLfViewTypes
        };
        break;
      
      // case ILfContextEnum.pens:
      //   ResultState = {
      //     ...ResultState,
      //     pens: payload as Location[]
      //   }
      //   break;
      
      case ILfContextEnum.error:
        ResultState = {
          ...ResultState,
          error: payload as ILfContext["error"]
        };
        break;
      case ILfContextEnum.clearError:
        ResultState = {
          ...ResultState,
          error: { Elementid: 0, errorText: "" }
        };
        break;

      default:
        console.error(`Unhandled action type: ${type}`);
        break;
    }
  });
  return ResultState;
}

export function dispatchErrorWithTimeout(dispatch: any, payload: ILfContext["error"], timeout = 2000) {
  dispatch({ error: payload });

  setTimeout(() => {
    dispatch({
      clearError: true
    });
  }, timeout);
}

export const useLfContext = () => {
  const context = useContext(LfContext);
  if (!context) {
    throw new Error("usePenContext must be used within a ModalProvider");
  }
  return context;
};